import React, { useEffect } from 'react'
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import RouteProvider from '../RouteProvider'
import pages from '../../pages'
import RouteChangeHandler from '../Reactor/RouteChangeHandler'

function RouteWrapper({ children }) {
  return <>{children}</>
}

// Normalizes the browser URL pathname to lowercase. Preserves search and hash.
function LowercaseRedirect() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    try {
      const { pathname, search, hash } = location
      const lower = pathname.toLowerCase()
      if (pathname !== lower) {
        // replace so we don't add a new history entry
        navigate(`${lower}${search || ''}${hash || ''}`, { replace: true })
      }
    } catch (e) {
      // if for some reason pathname is not a string, ignore
      // (keeps behavior resilient)
      // eslint-disable-next-line no-console
      console.error('LowercaseRedirect error', e)
    }
  }, [location, navigate])

  return null
}

const Router = () => (
  <BrowserRouter>
    {/* <LowercaseRedirect /> */}
    <RouteChangeHandler/>
    <RouteProvider value={pages}>
      {(context) => (
        <Routes>
          {context.routes.map((route, index) => (
            <Route
              key={index}
              element={<RouteWrapper>{route?.element}</RouteWrapper>}
              path={route.path}
            />
          ))}
        </Routes>
      )}
    </RouteProvider>
  </BrowserRouter>
)

export default Router
